import Switch from 'components/switch';
import { InfoDeliveryWire } from 'components/users/user-wire-transfers/types';
import React, { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import graphql from 'services/querys';
import { NewUserType } from 'v2-types/user';

type formType = NewUserType & {
  paymentAccounts: InfoDeliveryWire[];
};

type formNotificationsForm = {
  partyID: string;
};

const NotificationsForm: FC<formNotificationsForm> = ({ partyID }) => {
  const { t } = useTranslation();
  const { control, setValue } = useFormContext<formType>();
  const { mutate: updatePartyNotifications, ...responseUpdatePartyNotifications } = useMutation(
    graphql.updatePartyNotifications,
    {
      onSuccess: () => {
        responseUpdatePartyNotifications.reset();
      },
    }
  );

  return (
    <Controller
      control={control}
      name="notifications.all"
      render={({ field }) => (
        <Switch
          label={t('common:all')}
          checked={field.value}
          handleOnChange={(e, checked) => {
            setValue('notifications.all', checked);
          }}
          handleBlur={() => {
            updatePartyNotifications({
              id: partyID,
              data: {
                all: field.value,
              },
            });
          }}
        />
      )}
    />
  );
};

export default NotificationsForm;
